<ng-container *transloco="let t">
  <div class="flex flex-col gap-8 px-4">
    @if (isTacosStrategyPaused()) {
      <IAlert [title]="t('tacos-strategy.strategies_wont_deliver')" />
    }
    <div class="flex items-center gap-3">
      <h5 class="m-0 font-medium text-gray-800">{{ t("strategy-grid.sponsored_product") }}</h5>
      <div [iTooltip]="t('tacos-strategy.sp_cannot_be_paused')" class="flex">
        <IToggle [disabled]="true" [checked]="true" />
      </div>
    </div>

    <div class="flex items-center gap-3">
      <h5 class="m-0 font-medium text-gray-800">{{ t("strategy-grid.sponsored_display") }}</h5>
      <IToggle
        [checked]="isSdToggleChecked()"
        [loading]="sdLoadingState()"
        [iTooltip]="
          isSdToggleChecked() ? t('tacos-strategy.pause_sd_strategy') : t('tacos-strategy.activate_sd_strategy')
        "
        (checkedChange)="onSdToggleChange(!!$event)"
        [disabled]="isReadonly()"
      />
    </div>
    @if (tacosStrategy().sdStrategy) {
      <app-sd-strategy-targeting-list [strategy]="sdStrategyEx()!" />
    }

    <div class="flex items-center gap-3">
      <h5 class="m-0 font-medium text-gray-800">{{ t("strategy-page.sponsored_brand") }}</h5>
      <IToggle
        [checked]="isSbToggleChecked()"
        [loading]="sbLoadingState()"
        [iTooltip]="
          isSbToggleChecked() ? t('tacos-strategy.pause_sb_strategy') : t('tacos-strategy.activate_sb_strategy')
        "
        (checkedChange)="onSbToggleChange(!!$event)"
        [disabled]="isReadonly()"
      />
    </div>
    @if (isSbToggleChecked()) {
      @if (missingAsinsInSb()?.length) {
        <IAlert [title]="t('tacos-strategy.missing_asins_in_sb')" type="warning">
          {{ t("tacos-strategy.missing_asins_in_sb_description") }} <br />
          @for (asin of missingAsinsInSb(); track asin) {
            {{ asin + ($last ? "" : ", ") }}
          }
        </IAlert>
      }
      <div class="flex justify-end">
        <button iButton variant="secondary" [disabled]="!canCreateNewCreative() || isReadonly()" (click)="openSbForm()">
          <IIcon name="plus" />
          {{ t("sb-page.new_ad_line") }}
        </button>
      </div>
      <div class="mt-4 flex max-w-3xl flex-col gap-4">
        @for (creative of tacosStrategy().sbCreatives; track creative.creativeId) {
          <app-sb-creative-card
            [creative]="creative"
            [strategyId]="sbStrategyEx()!.strategyId"
            [creatives]="tacosStrategy().sbCreatives ?? []"
            [readOnly]="isReadonly()"
            [tacosStrategyGroupId]="tacosStrategy().tacosStrategyGroupId"
          />
        }
      </div>
    }
  </div>

  <ng-template #sdTargetingModal>
    <div class="flex h-[35vh] flex-col">
      <div class="flex-1">
        <app-sd-targeting-form (formChange)="sdTargetingFormValue.set($event)" />
      </div>
      <div class="flex justify-end gap-2">
        <button iButton variant="secondary" (click)="modalRef?.close()">{{ t("common.cancel") }}</button>
        <button
          iButton
          type="submit"
          [loading]="sdLoadingState()"
          [disabled]="!sdTargetingFormValue()?.isValid"
          (click)="activateSdStrategy()"
        >
          {{ t("common.create") }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
